// import { Injectable, inject } from '@angular/core';
// import {
//   Router,
//   ActivatedRouteSnapshot,
//   RouterStateSnapshot,
//   CanActivateFn,
// } from '@angular/router';
// import { Auth } from 'aws-amplify/auth';
// import { from, map, catchError, of } from 'rxjs';

// @Injectable({ providedIn: 'root' })
// class AdminGuard {
//   constructor(private router: Router) { }

//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//     return from(Auth.currentAuthenticatedUser()).pipe(
//       map(() => true),
//       catchError((error) => {
//         console.log('Not authenticated user', error);
//         // window.location.href = environment.amplify.loginPage;
//         return of(false);
//       }),
//     );
//   }
// }

// export const IsAdminGuard: CanActivateFn = (
//   route: ActivatedRouteSnapshot,
//   state: RouterStateSnapshot,
// ) => {
//   return inject(AdminGuard).canActivate(route, state);
// };
import { Injectable, inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
  CanActivateFn,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UAMAuthService } from '../services/uam-auth.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: UAMAuthService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.checkAuthentication().pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          window.location.href = environment.uamUrl;
          return false;
        }
        return true;
      }),
      catchError(() => {
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }
}

export const IsAdminGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuard).canActivate(route, state);
};
